var _$colors_5 = {
  red1: "#6C2315",
  red2: "#A23520",
  red3: "#D8472B",
  red4: "#E27560",
  red5: "#ECA395",
  red6: "#F5D1CA",
  orange1: "#714616",
  orange2: "#AA6A21",
  orange3: "#E38D2C",
  orange4: "#EAAA61",
  orange5: "#F1C696",
  orange6: "#F8E2CA",
  yellow1: "#77631B",
  yellow2: "#B39429",
  yellow3: "#EFC637",
  yellow4: "#F3D469",
  yellow5: "#F7E39B",
  yellow6: "#FBF1CD",
  teal1: "#0B403F",
  teal2: "#11605E",
  teal3: "#17807E",
  teal4: "#51A09E",
  teal5: "#8BC0BF",
  teal6: "#C5DFDF",
  blue1: "#28556F",
  blue2: "#3D7FA6",
  blue3: "#51AADE",
  blue4: "#7DBFE6",
  blue5: "#A8D5EF",
  blue6: "#D3EAF7"
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbG9ycy5qcyJdLCJuYW1lcyI6WyJtb2R1bGUiLCJyZWQxIiwicmVkMiIsInJlZDMiLCJyZWQ0IiwicmVkNSIsInJlZDYiLCJvcmFuZ2UxIiwib3JhbmdlMiIsIm9yYW5nZTMiLCJvcmFuZ2U0Iiwib3JhbmdlNSIsIm9yYW5nZTYiLCJ5ZWxsb3cxIiwieWVsbG93MiIsInllbGxvdzMiLCJ5ZWxsb3c0IiwieWVsbG93NSIsInllbGxvdzYiLCJ0ZWFsMSIsInRlYWwyIiwidGVhbDMiLCJ0ZWFsNCIsInRlYWw1IiwidGVhbDYiLCJibHVlMSIsImJsdWUyIiwiYmx1ZTMiLCJibHVlNCIsImJsdWU1IiwiYmx1ZTYiXSwibWFwcGluZ3MiOiJBQUFBQSxjQUFBQSxHQUFpQjtFQUNmQyxJQUFBQSxFQUFRLFNBRE87RUFDSUMsSUFBQUEsRUFBUSxTQURaO0VBQ3VCQyxJQUFBQSxFQUFRLFNBRC9CO0VBQzBDQyxJQUFBQSxFQUFRLFNBRGxEO0VBQzZEQyxJQUFBQSxFQUFRLFNBRHJFO0VBQ2dGQyxJQUFBQSxFQUFRLFNBRHhGO0VBRWZDLE9BQUFBLEVBQVcsU0FGSTtFQUVPQyxPQUFBQSxFQUFXLFNBRmxCO0VBRTZCQyxPQUFBQSxFQUFXLFNBRnhDO0VBRW1EQyxPQUFBQSxFQUFXLFNBRjlEO0VBRXlFQyxPQUFBQSxFQUFXLFNBRnBGO0VBRStGQyxPQUFBQSxFQUFXLFNBRjFHO0VBR2ZDLE9BQUFBLEVBQVcsU0FISTtFQUdPQyxPQUFBQSxFQUFXLFNBSGxCO0VBRzZCQyxPQUFBQSxFQUFXLFNBSHhDO0VBR21EQyxPQUFBQSxFQUFXLFNBSDlEO0VBR3lFQyxPQUFBQSxFQUFXLFNBSHBGO0VBRytGQyxPQUFBQSxFQUFXLFNBSDFHO0VBSWZDLEtBQUFBLEVBQVMsU0FKTTtFQUlLQyxLQUFBQSxFQUFTLFNBSmQ7RUFJeUJDLEtBQUFBLEVBQVMsU0FKbEM7RUFJNkNDLEtBQUFBLEVBQVMsU0FKdEQ7RUFJaUVDLEtBQUFBLEVBQVMsU0FKMUU7RUFJcUZDLEtBQUFBLEVBQVMsU0FKOUY7RUFLZkMsS0FBQUEsRUFBUyxTQUxNO0VBS0tDLEtBQUFBLEVBQVMsU0FMZDtFQUt5QkMsS0FBQUEsRUFBUyxTQUxsQztFQUs2Q0MsS0FBQUEsRUFBUyxTQUx0RDtFQUtpRUMsS0FBQUEsRUFBUyxTQUwxRTtFQUtxRkMsS0FBQUEsRUFBUyxTQUFBO0NBTC9HOUIsQ0FBQUEiLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==